module.exports = __webpack_public_path__ + "img/card_home1.26b462ea.svg";